import React, { useEffect, useState } from 'react'
import { Card, Form, Button, Row, Col, DatePicker, Spin, Table, Switch } from 'antd'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'
import BaseListing from 'src/BaseListings'
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper'
import WidgetDesignationSelector from 'src/widgets/Selectors/WidgetDesignationSelector'
const EmployeeWarningReport = () => {
  const Base = new BaseListing('employee_warning_report')
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()
  const [branchId, setBranchId] = useState(0)
  const [branchName, setBranchName] = useState('')
  const [SoDData, setSaleOrderDeliveryReportData] = useState([])
  const branches = wtGetFromLocalStorage('branches')
  const [dateRange, setDateRange] = useState([])
  const [Designations, setDesignations] = useState([])
  const [DesignationId, setDesignationId] = useState('')
  const [DesignationName, setDesignationName] = useState('')
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const changeValues = (key, val) => {
    setSaleOrderDeliveryReportData([])
    if (key === 'branch_id') {
      setBranchId(val.value)
      setBranchName(val.label)
    }
    if (key === 'date_range') {
      setDateRange(val)
    }
    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }
  }

  const exportToExcel = () => {
    setIsLoading(true)
    wtApiPostWithContentTypeHandling('sale_order_delivery_report/export', { data: SoDData })
    setIsLoading(false)
  }

  useEffect(() => {
    Base.dropdownData(
      'designations',
      {},
      [setDesignations],
      1,
    )
  }, [])

  const getReportData = () => {
    if (dateRange.length < 2) {
      lzNotifyErrorMessageFromResult('Please select date range')
      return
    }
    const fromDate = dateRange[0]
    const toDate = dateRange[1]
    setIsLoading(true)
    wtApiCall(
      'reports/employee_warning_report',
      {
        branch_id: branchId,
        from_date: fromDate.format('YYYY-MM-DD'),
        to_date: toDate.format('YYYY-MM-DD'),
      },
      'get',
      (response) => {
        setSaleOrderDeliveryReportData(response.data)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  }
  const columns = [
    {
      key: 'sr',
      title: 'Sr.No',
      render: (text, record, index) => index + 1,
      fixed: 'left',
      width: 60,
    },
    {
      key: 'employee_id',
      title: 'Employee ID',
      dataIndex: 'employee_id',
      width: 100,
    },
    {
      key: 'employee',
      title: 'Employee Name',
      render: (_, record) => record.employee.full_name || '-',
    },
    {
      key: 'designation',
      title: 'Designation',
      render: (_, record) => record.employee?.designation?.name || '-',
    },
    {
      key: 'department',
      title: 'Department',
      render: (_, record) => record.employee?.department?.name || '-',
    },
    {
      key: 'branch',
      title: 'Branch',
      render: (_, record) => record.employee?.branch?.name || '-',
    },
    {
      key: 'issue_date',
      title: 'Date of Issue',
      dataIndex: 'issue_date',
    },
    {
      key: 'letter_type',
      title: 'Type of (Warning/Advisory/Explanation/others)',
      render: () => 'Warning Letter', // or use `record.letter_type`
    },
    {
      key: 'reason',
      title: 'Reason for Warning/Advisory',
      dataIndex: 'reason',
    },
    {
      key: 'action_taken',
      title: 'Action Taken',
      render: (_, record) => record.action_taken || '-', // if available
    },
    {
      key: 'status',
      title: 'Status/Outcome',
      render: (_, record) => record.status || '-', // if available
    },
    {
      key: 'due_date',
      title: 'Follow-up Date',
      dataIndex: 'due_date',
    },
    {
      key: 'issued_by',
      title: 'Issued By',
      render: (_, record) => {
        const issuedBy = record.issued_by;
        if (!issuedBy) return '-';
        return `${issuedBy.first_name || ''} ${issuedBy.last_name || ''}`.trim();
      },
    },
    {
      key: 'is_response',
      title: 'Employee Response',
      render: (_, record) => {
        if (record.is_response === 1) return 'Yes';
        if (record.is_response === 2) return 'No';
        return '-';
      },
    },
  ];

  return (
    <div
      className="container-fluid"
      style={{
        padding: '1em',
        backgroundColor: 'white',
        minHeight: '100vh',
        fontFamily: 'Helvetica',
      }}
    >
      <Form
        layout={'vertical'}
        form={form}
        onFinish={getReportData}
        style={{ maxWidth: '100%', margin: '0 auto' }}
      >
        <Card
          style={{ width: '100%' }}
          title={
            <span style={{ fontSize: '26px', marginLeft: '45%' }}>Employee Warning Report</span>
          }
        >
          <Row gutter={[24, 24]}>
            <Col xs={15} sm={10} md={4}>
              <label>Date Range: *</label>
              <DatePicker.RangePicker
                onChange={(value) => {
                  setDateRange(value)
                  if (value && value.length === 2) {
                    setFromDate(value[0].format('YYYY-MM-DD'))
                    setToDate(value[1].format('YYYY-MM-DD'))
                  }
                }}
                style={{ width: '100%', height: 35 }}
                value={dateRange}
              />
            </Col>
            <Col xs={15} sm={10} md={4}>
              <label>Designation:</label>
              <WidgetDesignationSelector
                value={DesignationId}
                displayValue={DesignationName}
                designations={Designations}
                placeholder="Select Designation"
                onChange={(values) => changeValues('designation_id', values)}
                showCloudIcon={false}
              />
            </Col>
            <Col xs={15} sm={10} md={4}>
              <label>Branch:</label>
              <WidgetBranchSelector
                value={branchId}
                displayValue={branchName}
                branches={branches}
                placeholder="Select Branch"
                onChange={(values) => changeValues('branch_id', values)}
                showCloudIcon={false}
              />
            </Col>

            <Col xs={12} sm={8} md={6}>

              <Button
                style={{ marginTop: 30, marginRight: 5 }}
                type="primary"
                htmlType="submit"
                disabled={isLoading ? true : false}
              >
                Search
              </Button>
              {/* <Button
                style={{ marginTop: 30, backgroundColor: '#4BB543', color: '#fff' }}
                onClick={exportToExcel}
                disabled={isLoading ? true : false}
              >
                Export
              </Button> */}
            </Col>
          </Row>

        </Card>
      </Form>
      <Card style={{ marginTop: 20 }}>
        <Spin spinning={isLoading}>
          <Table
            columns={columns}
            dataSource={SoDData}
            rowKey="id"
            pagination={false}
            bordered
            scroll={{ x: 2500, y: 400 }} // Adjust width as needed
          />
        </Spin>
      </Card>
    </div>
  )
}
export default EmployeeWarningReport
